import type { Node as PMNode } from "@tiptap/pm/model";

/**
 * If the position after `range.to` begins a text node whose first character is a space,
 * widen the range by one so the inserted `mention + " "` replaces that space instead of
 * stacking an extra one (common when re-picking / editing an existing mention).
 *
 * @param doc - Current ProseMirror document
 * @param range - Replacement range for the mention insert
 */
export function extendMentionInsertRange(
  doc: PMNode,
  range: { from: number; to: number }
): { from: number; to: number } {
  const $end = doc.resolve(range.to);
  const after = $end.nodeAfter;
  if (after?.isText && after.text.startsWith(" ")) {
    return { from: range.from, to: range.to + 1 };
  }
  return range;
}
